module.exports = __webpack_public_path__ + "img/back pocket height.763f214b.png";